import { RootState } from 'editor/src/store/index';

function getFontDefinition(state: RootState, fontFamily: string) {
  return state.fonts.availableFonts.find((font) => font.metadata.fontFile === fontFamily);
}

export default getFontDefinition;
